import _ from 'lodash'

export default {
  setPageContent (state, content) {
    state.pages = content
  },
  setAppSettings (state, content) {
    state.settings = content
  },
  setGates (state, content) {
    state.gates = content
  },
  setSubscriptions (state, content) {
    state.subscriptions = content
  },
  setChallenges (state, content) {
    state.challenges = content
  },
  setTrialDays (state, content) {
    state.trialDays = content
  },
  setActivePage (state, content) {
    state.activePage = content
  },
  setActiveChallengePage (state, content) {
    state.activeChallengePage = content
  },
  setUser (state, content) {
    const clonedContent = _.cloneDeep(content)
    if (content && content.profile && content.profile.subscription_plan_type) {
      clonedContent.profile.subscription_plan_type = clonedContent.profile.subscription_plan_type.toLowerCase()
    }
    state.user = clonedContent
  },
  setCouponData (state, content) {
    state.couponData = content
  },
  setSelectedOrder (state, content) {
    state.selectedOrder = content
  },
  setFromChallenge (state, content) {
    state.fromChallenge = content
  },
  showAlert (state, content) {
    state.showAlert = content
  },
  setSelectedSubscription (state, content) {
    state.selectedSubscription = content
  },
  setLocale (state, content) {
    state.locale = content
  },
  setAuthModalType (state, content) {
    state.authModalType = content
  }
}
